import styles from '../about/aboutSection.css';
import aboutImage from './../../../pages/about.jpg';
import Section from '../section';
import whatsUpImage from './../../../WhatsAppButtonGreenLarge.png';

function ContactSection() {
    return (
        <Section title="KONTAKT">
            <div>
                Skontaktuj się z nami< br />
                <a aria-label="Chat on WhatsApp" href="https://wa.me/1XXXXXXXXXX"><img alt="Chat on WhatsApp" src={whatsUpImage} /></a>
            </div>
        </Section>
    )
}

export default ContactSection;